/**
 * @returns {String}
 * @description Makes the userlevel look nice
 */
export function userLevel(user) {
  var userLevel = user
  try {
    if (typeof user !== 'undefined' && user !== '') {
      switch (user) {
        case 'superadmin':
          userLevel = 'Super Admin'
          break
        case 'agencyadmin':
          userLevel = 'Agency Admin'
          break
        case 'agencyuser':
          userLevel = 'Agency User'
          break
        case 'organadmin':
          userLevel = 'Organisation Admin'
          break
        case 'organuser':
          userLevel = 'Organisation User'
          break
        case 'accountadmin':
          userLevel = 'Account Admin'
          break
        case 'accountuser':
          userLevel = 'Account User'
          break
        case 'reporter':
          userLevel = 'Account Reporter'
          break
        case 'emailrecipient':
          userLevel = 'Account Email Recipient'
          break
        case 'developer':
          userLevel = 'Developer'
          break
      }
      return userLevel
    }
  } catch (e) /* istanbul ignore next */ {
    return undefined
  }
}
